import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { tap } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less'],
})
export class HomeComponent extends BaseComponent implements OnInit {
  constructor(injector: Injector) {
    super(injector);
  }
  dashboards: { code: string; value: string }[] = [];
  ngOnInit() {
    this.getDashbaords();
  }
  getDashbaords() {
    this.layoutService
      .getDashboards()
      .pipe(
        tap((response: any) => {
          this.dashboards = Object.keys(response).map((x) => {
            return {
              code: x,
              value: response[x],
            };
          });
        })
      )
      .subscribe();
  }
}
